import axios from 'axios';
import { toast } from 'sonner';

export const downloadPdf = async (url, filename) => {
  const t = toast.loading('Génération du PDF…');
  try {
    const resp = await axios.get(url, { responseType: 'blob', withCredentials: true, timeout: 45000 });
    const blob = new Blob([resp.data], { type: 'application/pdf' });
    const objectUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => window.URL.revokeObjectURL(objectUrl), 20000);
    toast.success('PDF téléchargé', { id: t });
  } catch (err) {
    let detail = 'Erreur lors du téléchargement du PDF';
    if (err.response?.data instanceof Blob) {
      try { detail = JSON.parse(await err.response.data.text()).detail || detail; } catch { /* ignore */ }
    } else if (err.code === 'ECONNABORTED') {
      detail = 'Délai dépassé — réessayez';
    }
    toast.error(`${detail}${err.response?.status ? ` (HTTP ${err.response.status})` : ''}`, { id: t });
  }
};
